export const determineIsDrupal403 = () => {
  return typeof window !== 'undefined' &&
    window.Drupal &&
    window.Drupal.settings &&
    window.Drupal.settings.rm &&
    window.Drupal.settings.rm.is403;
};

export const determineIsDrupal404 = () => {
  return typeof window !== 'undefined' &&
    window.Drupal &&
    window.Drupal.settings &&
    window.Drupal.settings.rm &&
    window.Drupal.settings.rm.is404;
};

export const determineIsDrupal500 = () => {
  return typeof window !== 'undefined' &&
    window.Drupal &&
    window.Drupal.settings &&
    window.Drupal.settings.rm &&
    window.Drupal.settings.rm.is500;
};

export default {
  determineIsDrupal403,
  determineIsDrupal404,
  determineIsDrupal500,
};
